import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { UtmCapture } from '../components/UtmCapture';
import { flowAndPauseDetails, flowAndPauseGallery, flowAndPauseHosts, flowAndPauseProgram } from '../data/flowAndPause';
const WHATSAPP_URL = `https://wa.me/972548800260?text=${encodeURIComponent('היי עדי, אשמח להירשם לסדנת "צילום ומים – בין זרימה לעצירה" ב-24.10')}`;
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/hCYHGrw2S49vUeNeh2meK8/tali-kinneret.webp';
const PROGRAM_IMAGE = 'https://cdn.magicpatterns.com/uploads/oA2BS8qcd7MXHEKX1PSjGm/adi-ice-bath.webp';
export function FlowAndPausePage() {
  useEffect(() => {
    document.title = "צילום ומים – בין זרימה לעצירה | ביץ' קלאב מעגן";
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', "סדנת דואט לנשים עם טלי הראל אבן ועדי שמעוני: צילום מים, נשימה מודעת ואמבט קרח. שבת 24.10, 09:00–13:00, ביץ' קלאב מעגן עדן.");
  }, []);
  const trackLead = () => {
    if (window.fbq) {
      window.fbq('trackCustom', 'wa_flow', {
        content_name: 'צילום ומים – בין זרימה לעצירה',
        content_category: 'Flow and Pause Workshop'
      });
    }
  };
  return <div dir="rtl" className="min-h-screen w-full bg-white text-slate-900" data-id="element-1297" data-mp="3sgg436veslf0">
      <UtmCapture data-id="element-1298" data-mp="3drjrqxmbkm8l" />

      <main data-id="element-1299" data-mp="3ds3bmjvj5kp9">
        <section className="relative flex min-h-[620px] items-end overflow-hidden bg-[#073F5F] md:min-h-screen" data-id="element-1300" data-mp="3dsle3y8scv5m">
          <img src={HERO_IMAGE} alt="טלי מצלמת על חוף הכנרת, גולשות סאפ ברקע" className="absolute inset-0 h-full w-full object-cover object-[75%_center]" data-id="element-1301" data-mp="3inqukhjf5hmb" />
          <div className="absolute inset-0 bg-[#073F5F]/55" aria-hidden="true" data-id="element-1302" data-mp="38ti7i9d5qgvj" />
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative mx-auto w-full max-w-7xl px-5 pb-16 pt-20 text-white md:px-8 md:pb-24" data-id="element-1303" data-mp="1fa9hzrtr4783">
            <p className="text-lg font-semibold text-cyan-200" data-id="element-1304" data-mp="10ln1hmse19fa">
              סדנת דואט לנשים · טלי הראל אבן ועדי שמעוני
            </p>
            <h1 className="mt-2 font-bold leading-[1.02] tracking-tight" data-id="element-1305" data-mp="1t8py29di7a2w">
              <span className="block text-6xl md:text-8xl" data-id="element-1306" data-mp="1t6mzh0yac8mk">צילום ומים</span>
              <span className="mt-3 block text-3xl font-medium md:text-5xl" data-id="element-1307" data-mp="1o8btx2f0wka5">
                בין זרימה לעצירה
              </span>
            </h1>
            <p className="mt-6 max-w-xl text-xl leading-relaxed text-white/90 md:text-2xl" data-id="element-1308" data-mp="cuhpxjthd3as">
              מפגש של נשים שלומדות לנשום וליצור.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-5" data-id="element-1309" data-mp="8rbbvq04m7tr">
              <a href="#registration" className="whitespace-nowrap rounded-full bg-white px-8 py-4 text-lg font-semibold text-[#0A5F8F] transition-colors duration-150 hover:bg-cyan-50" data-id="element-1310" data-mp="2kh11p0bkhg39">
                להרשמה לסדנה
              </a>
              <p className="text-lg text-white/85" data-id="element-1311" data-mp="2y7cvr4rppox1">
                שבת 24.10 · 09:00–13:00 · מעגן עדן
              </p>
            </div>
          </motion.div>
        </section>

        <dl className="bg-[#0A5F8F] text-white" data-id="element-1312" data-mp="339242cnjvohf">
          <div className="mx-auto grid max-w-7xl gap-px bg-white/15 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1313" data-mp="384rbf25ta9oa">
            {flowAndPauseDetails.map(detail => <div key={detail.label} className="bg-[#0A5F8F] px-5 py-7 md:px-8" data-id="element-1314" data-mp="3h6id7vx8dwcv">
                <dt className="text-sm font-semibold text-cyan-200" data-id="element-1315" data-mp="3h4ea3g75p1dn">
                  {detail.label}
                </dt>
                <dd className="mt-2 text-xl font-bold md:text-2xl" data-id="element-1316" data-mp="1ms7orokjt47m">
                  {detail.value}
                </dd>
                <dd className="mt-1 text-white/80" data-id="element-1317" data-mp="rhhyguizdy4d">{detail.note}</dd>
              </div>)}
          </div>
        </dl>

        <section className="bg-white py-20 md:py-28" data-id="element-1318" data-mp="miogopwnvkye">
          <div className="mx-auto max-w-4xl px-5 text-center md:px-8" data-id="element-1319" data-mp="11h0fb23lh3s7">
            <p className="text-3xl font-semibold leading-snug text-[#0A5F8F] md:text-5xl md:leading-tight" data-id="element-1320" data-mp="11e4i5fzkmj4t">
              המים מזמינים אותנו לנוע.
              <br data-id="element-1321" data-mp="8suukfcjjesd" />
              הקור מזמין אותנו לעצור.
            </p>
            <p className="mx-auto mt-6 max-w-2xl text-xl leading-relaxed text-slate-600" data-id="element-1322" data-mp="3sypsdw0rjbr">
              בוקר על שפת הכנרת שבו נלמד להסתכל אחרת – על המים, על האור ועל
              עצמנו. נצלם תנועה והשתקפויות, נעצור לנשימה מודעת, ונפגוש את הקור
              באמבט קרח.
            </p>
          </div>
        </section>

        <section className="bg-sky-50 py-20 md:py-28" data-id="element-1323" data-mp="3m5whjxinr5uu">
          <div className="mx-auto grid max-w-7xl gap-12 px-5 md:px-8 lg:grid-cols-12 lg:gap-16" data-id="element-1324" data-mp="3m4d0w5t3assj">
            <div className="lg:col-span-7" data-id="element-1325" data-mp="3h5sbl1fdltiv">
              <h2 className="text-4xl font-bold tracking-tight text-[#0A5F8F] md:text-5xl" data-id="element-1326" data-mp="1wpat87htbth9">
                מה בתכנית?
              </h2>
              <ol className="mt-10 border-t border-[#0A5F8F]/20" data-id="element-1327" data-mp="21hlqt3p2z36n">
                {flowAndPauseProgram.map((item, index) => <li key={item.title} className="grid grid-cols-[48px_1fr] gap-4 border-b border-[#0A5F8F]/20 py-7" data-id="element-1328" data-mp="1rqhd07b55ode" data-mpi={index}>
                    <span className="text-3xl font-bold text-cyan-700" aria-hidden="true" data-id="element-1329" data-mp="2fdz563ybiogw">
                      {index + 1}
                    </span>
                    <div data-id="element-1330" data-mp="2agyzhu5drnqb">
                      <h3 className="text-2xl font-bold" data-id="element-1331" data-mp="2ag7hjm4phoii">{item.title}</h3>
                      <p className="mt-2 text-lg leading-relaxed text-slate-600" data-id="element-1332" data-mp="v08daly7mcnj">
                        {item.description}
                      </p>
                    </div>
                  </li>)}
              </ol>
            </div>
            <img src={PROGRAM_IMAGE} alt="עדי מלווה משתתפת באמבט קרח" className="aspect-[3/4] w-full rounded-2xl object-cover lg:col-span-5 lg:self-center" data-id="element-1333" data-mp="31n61yawxj8u3" />
          </div>
        </section>

        <section className="bg-white py-20 md:py-28" data-id="element-1334" data-mp="2mzkvc70uirhf">
          <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-1335" data-mp="2mz1q9qwanxkt">
            <h2 className="text-4xl font-bold tracking-tight text-[#0A5F8F] md:text-5xl" data-id="element-1336" data-mp="2iyivpp30odex">
              מי מנחות
            </h2>
            <div className="mt-12 grid gap-12 md:grid-cols-2 md:gap-10" data-id="element-1337" data-mp="2dy3jx1ydvdz2">
              {flowAndPauseHosts.map(host => <article key={host.name} className="grid grid-cols-[112px_1fr] items-start gap-6 sm:grid-cols-[160px_1fr]" data-id="element-1338" data-mp="2901yiadhj2kf">
                  <img src={host.image} alt={host.alt} className="aspect-[3/4] w-full rounded-2xl object-cover" data-id="element-1339" data-mp="775dpvtrwln4" />
                  <div data-id="element-1340" data-mp="apl2b4k4vlni">
                    <h3 className="text-2xl font-bold md:text-3xl" data-id="element-1341" data-mp="aq4b9vrt2zpe">
                      {host.name}
                    </h3>
                    <p className="mt-1 font-semibold text-cyan-700" data-id="element-1342" data-mp="jiob2zju3abt">
                      {host.role}
                    </p>
                    <p className="mt-3 text-lg leading-relaxed text-slate-600" data-id="element-1343" data-mp="oi0xjj6smfdv">
                      {host.bio}
                    </p>
                  </div>
                </article>)}
            </div>
          </div>
        </section>

        <section className="bg-white pb-20 md:pb-28" data-id="element-1344" data-mp="3s0khzzj8cgy4">
          <div className="mx-auto grid max-w-7xl grid-cols-2 gap-4 px-5 md:grid-cols-3 md:gap-5 md:px-8" data-id="element-1345" data-mp="r5at0h72adh">
            {flowAndPauseGallery.map((photo, index) => <img key={photo.src} src={photo.src} alt={photo.alt} loading="lazy" className={`w-full rounded-2xl object-cover ${index === 2 ? 'col-span-2 aspect-[3/2] md:col-span-1 md:aspect-[3/4]' : 'aspect-[3/4]'}`} data-id="element-1346" data-mp="1c7bzv53skhu4" data-mpi={index} />)}
          </div>
        </section>

        <section id="registration" className="scroll-mt-6 bg-[#073F5F] py-20 text-white md:py-24" data-id="element-1347" data-mp="1yaqgesefwz3b">
          <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-5 md:flex-row md:items-center md:px-8" data-id="element-1348" data-mp="279k8q6kqn3b2">
            <div className="max-w-2xl" data-id="element-1349" data-mp="2lxoqn8byvass">
              <h2 className="text-4xl font-bold tracking-tight md:text-5xl" data-id="element-1350" data-mp="2m0ks36n0whlz">
                שומרות לך מקום?
              </h2>
              <p className="mt-4 text-xl leading-relaxed text-white/85" data-id="element-1351" data-mp="2uz69gygrdql6">
                ₪450 למשתתפת · שבת 24.10, 09:00–13:00 · ביץ' קלאב מעגן עדן.
                מספר המקומות מוגבל – שלחי הודעה ונחזור אלייך עם כל הפרטים.
              </p>
            </div>
            <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" onClick={trackLead} className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white px-7 py-3.5 text-lg font-semibold text-[#0A5F8F] transition-colors duration-150 hover:bg-cyan-50" data-id="element-1352" data-mp="10lnarlazs1ya">
              <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-1353" data-mp="2yhvh1atqxxhr" />
              להרשמה בוואטסאפ
            </a>
          </div>
        </section>

        <div className="sticky bottom-0 z-30 border-t border-slate-200 bg-white/95 px-5 py-3 backdrop-blur md:hidden" data-id="element-1354" data-mp="32gb2vbe3cztl">
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" onClick={trackLead} className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-[#0A5F8F] px-7 py-3.5 text-lg font-semibold text-white transition-colors duration-150 hover:bg-[#073F5F]" data-id="element-1355" data-mp="2thpolsfnk6ym">
            <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-1356" data-mp="drml1jb7vrc3" />
            להרשמה · ₪450
          </a>
        </div>
      </main>

      <Footer data-id="element-1357" data-mp="31x56mxyhfgrv" />
    </div>;
}